import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import useFabricDetails from 'data-hooks/useFabricDetails';
import useFabricReviews from 'data-hooks/useFabricReviews';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_FABRIC_GALLERY_DATA } from 'mocks/queries';
import PDPFabricDetailSidebarUI from './PDPFabricDetailSidebarUI';

const PDPFabricDetailSidebar = ({
  isOpen,
  onClose,
  fabricId,
  mode = 'pdp',
  galleryType,
  mobileHideHeader,
}) => {
  const zoomImgProps = { w: 1800, h: 915 };
  const jbImgProps = { height: 300, width: 590 };
  const {
    loading,
    error,
    data: { selectedFabric },
  } = useFabricDetails(fabricId);

  const { data: fabricsGalleryData } = useSuspenseQuery(
    GET_FABRIC_GALLERY_DATA,
    {
      variables: { fromCache: true },
    }
  );

  const imgProps = useMemo(
    () => ({
      auto: 'format,compress',
      fit: 'fill',
      crop: 'entropy',
      h: 430,
      w: 875,
    }),
    []
  );

  useEffect(() => {
    const URL_PREFIX = 'https://joybird2.imgix.net/fabric-swatches/t1/';
    const itemData = fabricsGalleryData?.getFabricGalleryData ?? {};
    if (selectedFabric && Object.keys(selectedFabric).length > 0) {
      Object.keys(itemData).forEach(key => {
        if (key === `${selectedFabric?.option_value_id}`) {
          let itemGalleryData = itemData[key];
          if (itemGalleryData) {
            try {
              itemGalleryData = JSON.parse(itemGalleryData);
            } catch (e) {
              itemGalleryData = null;
            }
          }

          const { img_prefix = '', img_suffixes = '' } = itemGalleryData;
          const img_suffixesList = img_suffixes.length
            ? img_suffixes.split(',')
            : null;
          const images = [];
          for (let i = 0; i < img_suffixesList?.length; i++) {
            const obj = {
              url: URL_PREFIX.concat(
                img_prefix,
                `-t1-${img_suffixesList[i]}.jpg`
              ),
              isVideo: false,
              imgProps,
              zoomUrl: URL_PREFIX.concat(
                img_prefix,
                `-t1-${img_suffixesList[i]}.jpg`
              ),
              videoProps: {},
              className: '',
              zoomImgProps,
              jbImgProps,
            };
            images.push(obj);
          }

          selectedFabric.sliderImages = images;
        }
      });
    }
    // eslint-disable-next-line
  }, [fabricsGalleryData, selectedFabric]);

  const {
    loading: reviewsLoading,
    error: reviewsError,
    data: { reviews, rating },
  } = useFabricReviews(fabricId);

  if (error) {
    return null;
  }

  return (
    <PDPFabricDetailSidebarUI
      isOpen={isOpen}
      loading={loading}
      mode={mode}
      onClose={onClose}
      rating={rating}
      reviews={reviews}
      reviewsError={reviewsError}
      reviewsLoading={reviewsLoading}
      selectedFabric={selectedFabric}
      galleryType={galleryType}
      mobileHideHeader={mobileHideHeader}
    />
  );
};

PDPFabricDetailSidebar.propTypes = {
  fabricId: PropTypes.number,
  isOpen: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onClose: PropTypes.func,
  galleryType: PropTypes.string,
  mobileHideHeader: PropTypes.bool,
};

export default PDPFabricDetailSidebar;
